export const API = {
	auth: {
		login: `/user/login`,
		check2FA: `/user/check2FA`,
		requestReset: `/user/request-reset-password`,
		resetPassword: `/user/reset-password`,
	},
	users: {
		profile: `/user/profile`,
		create: `/user/register/`,
		edit: `/user/`,
		delete: `/user/`,
		list: `/user`,
	},
	alerts: {
		create: `/alert`,
		edit: `/alert/`,
		delete: `/alert/`,
		list: `/alert`,
	},
	projects: {
		tasksSummary: (projectId) => `/project/${projectId}/tasks-summary`,
		downloadDocument: (projectId) => `/project/${projectId}/documents/download`,
	},
};
